const electronLatest = '/electron/latest'
//const electronLatest = 'https://stage.flomoapp.com/version.json'

export { electronLatest }
